import { Link } from 'wouter';
import { PageBreadcrumb } from '@/components/sections/PageBreadcrumb';
import { Footer } from '@/components/sections/Footer';
import { useSeo } from '@/lib/useSeo';
import { usePrerenderReady } from '@/hooks/usePrerenderReady';

/** The existing configurators stay in the code, but never mount while unavailable. */
export default function CreatorComingSoon() {
  useSeo({
    title: 'Kreator bukietów — wkrótce',
    description: 'Kreator bukietów będzie dostępny wkrótce. Poznaj gotowe bukiety w Bukietowej.',
    robots: 'noindex, follow',
  });
  usePrerenderReady();

  return (
    <div className="min-h-[100dvh] bg-white">
      <PageBreadcrumb crumbs={[{ label: 'Kreator bukietów' }]} />
      <main data-testid="creator-coming-soon" className="mx-auto max-w-2xl px-6 pb-24 pt-28 text-center">
        <p className="mb-4 text-sm tracking-widest text-muted-foreground">KREATOR BUKIETÓW</p>
        <h1 className="mb-6 font-serif text-5xl text-foreground">Wkrótce</h1>
        <p className="mb-8 text-base leading-relaxed text-muted-foreground">Kreator bukietów będzie dostępny wkrótce. W tym czasie zapraszamy do wyboru gotowej kompozycji.</p>
        <Link href="/bukiety/" className="inline-flex min-h-11 items-center rounded-full bg-[#2A1F14] px-6 py-3 text-sm font-medium text-white hover:bg-[#49372c] focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-4">Zobacz bukiety</Link>
      </main>
      <Footer />
    </div>
  );
}
